import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';


function Alert(props: any) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
}));

export default function SnackbarCommon(props: any) {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Snackbar open={props.open ? true : false} autoHideDuration={6000} onClose={() => { props.handleopenClose(false) }}>
                <Alert onClose={() => { props.handleopenClose(false) }} >
                    {props.text}
                </Alert>
            </Snackbar>
        </div>
    );
}
